import LottieView from "lottie-react-native";
import { useDispatch } from "react-redux";
import LinearGradient from "react-native-linear-gradient";
import React, { useState, useEffect } from "react";
import {
  StyleSheet,
  View,
  ScrollView,
  Modal,
  Image,
  TouchableOpacity,
} from "react-native";

//Custom Imports
import color from "@constants/color";
import { scale } from "@utils/scale";
import t from "@constants/localization";
import Cross from "@assets/svg/CrossIcon";
import CustomText from "@components/CustomText";
import { PERFROMANCE_TYPES } from "../ContestEvents";
import CLAppLogo from "@assets/svg/Jrny/CLAppLogo";
import contestAction from "@actions/contest.action";
import { setContestResultViewed } from "@services/api";
import DottedLine from "@assets/svg/Contest/DottedLine";
import { CONTEST_EVENTS } from "@constants/analyticsEventsCT";
import ContestBadIcon from "@assets/svg/Contest/BadContestIcon";

const PATH = "screens/Contest/contestDetails";

const AnnouncementBanner = ({
  visible,
  setVisible,
  item = {},
  tl_image = "",
  tl_name = "",
  navigation = () => {},
  trackEvent = () => {},
  contestId = "",
  performance = "",
}) => {
  const {
    current_slab_index = 0,
    customers_made = "",
    level_reached = "",
    rewards_earned = "",
  } = item;
  const dispatch = useDispatch();
  const [loop, setLoop] = useState(true);

  const toggleFilters = () => {
    dispatch(
      contestAction.getContestDetailsContest.pending(
        { contest_id: contestId },
        null,
      ),
    );
    setVisible(false);
  };

  useEffect(() => {
    if (visible) {
      setContestResultViewed({ contestId });
      trackEvent(CONTEST_EVENTS.RESULT_FULL_PAGE_LANDED, {
        screen: "Result Full page",
        level: level_reached,
        reward: rewards_earned,
        metric_name: "Customers made",
        metric: customers_made,
      });
    }
  }, [visible]);

  const captureAndShare = () => {
    if (performance !== PERFROMANCE_TYPES.BAD) {
      trackEvent(CONTEST_EVENTS.RESULT_SHARED, {
        screen: "Result Full page",
        level: level_reached,
        reward: rewards_earned,
        metric_name: "Customers made",
        metric: customers_made,
      });
    }
    toggleFilters();
  };

  return (
    <Modal
      transparent
      visible={visible}
      onRequestClose={toggleFilters}
      animationType="slide"
    >
      <ScrollView
        style={styles.container}
        contentContainerStyle={styles.contentContainerStyle}
        showsVerticalScrollIndicator={false}
        onTouchStart={() => {
          loop && setLoop(false);
        }}
      >
        <LottieView
          style={styles.lottieContainer}
          source={require("../../../assets/anim/conffettiTeamGuide.json")}
          autoPlay={loop}
          loop={loop}
        />
        <View style={styles.headerContainer}>
          <TouchableOpacity
            activeOpacity={0.8}
            onPress={toggleFilters}
            style={styles.crossIcon}
          >
            <Cross />
          </TouchableOpacity>
          {performance !== PERFROMANCE_TYPES.BAD ? (
            <View style={styles.profileView}>
              <Image
                resizeMode={"stretch"}
                style={styles.profileBack}
                source={require("../../../assets/images/contestProfileBackground.png")}
              />
              {performance === PERFROMANCE_TYPES.EXCELLENT ? (
                <Image
                  source={require("../../../assets/images/contest_winner.png")}
                  style={styles.excellentIcon}
                />
              ) : null}
              <Image
                source={require("../../../assets/images/contest_congrats.png")}
                style={[
                  styles.goodIcon,
                  {
                    top:
                      performance === PERFROMANCE_TYPES.EXCELLENT
                        ? scale(150)
                        : scale(125),
                  },
                ]}
              />
              {tl_image &&
              tl_image !==
                "https://storage.googleapis.com/cm-catalogue-images/1589963078748leader_image.png" ? (
                <View style={styles.logoContainer}>
                  <Image
                    resizeMode={"cover"}
                    style={styles.profileImage}
                    source={{ uri: tl_image }}
                  />
                </View>
              ) : (
                <View style={styles.logoContainer}>
                  <CLAppLogo height={77} width={77} />
                </View>
              )}
            </View>
          ) : (
            <View style={styles.badContestContainer}>
              <ContestBadIcon />
            </View>
          )}
          <CustomText
            variant="title_18"
            newfont={true}
            style={[
              styles.customerMessage,
              {
                marginTop:
                  performance === PERFROMANCE_TYPES.EXCELLENT
                    ? scale(100)
                    : performance === PERFROMANCE_TYPES.GOOD
                      ? scale(65)
                      : scale(25),
              },
            ]}
          >
            {performance === PERFROMANCE_TYPES.EXCELLENT
              ? t(`${PATH}/performed_excellent`, { name: tl_name })
              : performance === PERFROMANCE_TYPES.GOOD
                ? t(`${PATH}/performed_good`, { name: tl_name })
                : t(`${PATH}/performed_bad`)}
          </CustomText>
        </View>
        <View style={styles.mainCardContainer}>
          <LinearGradient
              colors={["#FFDF77", "#FCC938"]}
              style={styles.myTaskCard}
            >
              <View style={styles.header}>
                <CustomText
                  variant="title_20"
                  newfont={true}
                  numberOfLines={1}
                  style={styles.nameText}
                >
                  {t(`${PATH}/rewardsEarned`)}
                </CustomText>
              </View>
              <DottedLine style={styles.dottedLine} width={"100%"} />
              <View style={styles.rewardContainer}>
                <Image
                  resizeMode={"contain"}
                  style={styles.rewardIcon}
                  source={require("../../../assets/images/rewardIcon.png")}
                />
                <CustomText
                  variant="heading_24"
                  newfont={true}
                  style={styles.rewardText}
                >
                  {`₹${rewards_earned}`}
                </CustomText>
              </View>
              <View style={styles.customerLevelContainer}>
                <View style={styles.viewContainer}>
                  <CustomText
                    variant="body_text_3"
                    newfont={true}
                    numberOfLines={1}
                    style={styles.customerText}
                  >
                    {t(`${PATH}/customersMade`)}
                  </CustomText>
                  <CustomText
                    variant="heading_24"
                    newfont={true}
                    numberOfLines={1}
                    style={styles.digitText}
                  >
                    {customers_made}
                  </CustomText>
                </View>
                <View style={styles.viewContainer}>
                  <CustomText
                    variant="body_text_3"
                    newfont={true}
                    numberOfLines={1}
                    style={styles.customerText}
                  >
                    {t(`${PATH}/levelReached`)}
                  </CustomText>
                  <CustomText
                    variant="heading_24"
                    newfont={true}
                    numberOfLines={1}
                    style={styles.digitText}
                  >
                    {level_reached}
                  </CustomText>
                </View>
              </View>
            </LinearGradient>
          <TouchableOpacity
            onPress={captureAndShare}
            style={styles.shareButton}
          >
            <CustomText
              variant="title_18_semi"
              newfont={true}
              numberOfLines={1}
              style={styles.shareText}
            >
              {performance === PERFROMANCE_TYPES.BAD
                ? t(`${PATH}/backToContestPage`)
                : t(`${PATH}/shareYourResult`)}
            </CustomText>
          </TouchableOpacity>
        </View>
      </ScrollView>
    </Modal>
  );
};

export default AnnouncementBanner;

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: color.yellow_back,
  },
  contentContainerStyle: {
    paddingBottom: 20,
    paddingHorizontal: 16,
  },
  mainCardContainer: {},
  myTaskCard: {
    flexDirection: "column",
    elevation: 8,
    shadowColor: color.mediumBlack,
    shadowOffset: { width: 2, height: 2 },
    shadowOpacity: 0.25,
    shadowRadius: 4.65,
    borderRadius: scale(10),
    backgroundColor: color.white,
    marginTop: scale(20),
    padding: 16,
    minHeight: scale(350),
  },
  header: {
    width: "100%",
    justifyContent: "center",
    alignItems: "center",
  },
  nameText: {
    color: color.mediumBlack,
    maxWidth: "80%",
  },
  dottedLine: {
    marginTop: 12,
    alignSelf: "center",
  },
  rewardIcon: {
    width: scale(140),
    height: scale(140),
    marginTop: 11,
  },
  rewardContainer: {
    width: scale(140),
    height: scale(140),
    alignSelf: "center",
    justifyContent: "center",
    alignItems: "center",
  },
  rewardText: {
    color: color.white,
    position: "absolute",
    maxWidth: scale(70),
  },
  customerLevelContainer: {
    marginTop: 15,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-around",
  },
  customerText: {
    color: color.mediumBlack,
  },
  digitText: {
    color: color.mediumBlack,
    marginTop: 4,
  },
  viewContainer: {
    alignItems: "center",
  },
  crossIcon: {
    alignSelf: "flex-end",
    zIndex: 10,
  },
  headerContainer: {
    marginTop: 20,
  },
  profileView: {
    alignItems: "center",
  },
  profileBack: {
    width: "100%",
    height: 130,
    position: "absolute",
  },
  profileImage: {
    width: 85,
    height: 85,
    borderRadius: 48,
  },
  customerName: {
    color: color.mediumBlack,
    alignSelf: "center",
    marginTop: 15,
  },
  customerMessage: {
    color: color.light_text_yellow,
    alignSelf: "center",
    marginTop: scale(100),
    lineHeight: 24,
    textAlign: "center",
  },
  shareButton: {
    backgroundColor: "#4E3400",
    paddingHorizontal: 16,
    paddingVertical: 14,
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 8,
    position: "absolute",
    width: "90%",
    bottom: scale(12),
    alignSelf: "center",
    zIndex: 200,
  },
  shareText: {
    color: color.white,
    lineHeight: 24,
  },
  lottieContainer: {
    flex: 1,
    position: "absolute",
    elevation: 5,
  },
  excellentIcon: {
    top: scale(20),
    position: "absolute",
  },
  goodIcon: {
    position: "absolute",
    top: scale(150),
  },
  logoContainer: {
    width: 96,
    height: 96,
    borderRadius: 50,
    marginTop: 40,
    justifyContent: "center",
    alignItems: "center",
    elevation: 8,
    shadowColor: color.mediumBlack,
    shadowOffset: { width: 2, height: 2 },
    shadowOpacity: 0.25,
    shadowRadius: 4.65,
    backgroundColor: "rgba(249, 211, 97, 0.9)",
  },
  badContestContainer: {
    justifyContent: "center",
    alignItems: "center",
    marginTop: scale(70),
  },
});
